export default "__VITE_ASSET__BdaKJLV4__"